import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackgroundAnimation from './BackgroundAnimation';
import './Profile.css';
import ShinyText from './ShinyText';

const Profile = () => {
  const [displayedEmail, setDisplayedEmail] = useState('');
  const email = 'jlefortbesnard@tuta.io';
  const typingSpeed = 150;
  const pauseDuration = 1000;
  const eraseSpeed = 20;
  const navigate = useNavigate();

  useEffect(() => {
    let currentIndex = 0;
    let isTyping = true;
    const animationInterval = setInterval(() => {
      if (isTyping) {
        if (currentIndex <= email.length) {
          setDisplayedEmail(email.slice(0, currentIndex));
          currentIndex++;
        }
        if (currentIndex > email.length) {
          setTimeout(() => {
            isTyping = false;
          }, pauseDuration);
        }
      } else {
        if (currentIndex >= 2) {
          setDisplayedEmail(email.slice(0, currentIndex));
          currentIndex--;
        }
        if (currentIndex < 2) {
          isTyping = true;
        }
      }
    }, isTyping ? typingSpeed : eraseSpeed);
    return () => clearInterval(animationInterval);
  }, [email]);

  const navLinks = [
    { label: 'CV', action: () => navigate('/CV') },
    { label: 'Publications scientifiques', action: () => navigate('/publications') },
  ];

  const handlePrivateAreaClick = () => {
    navigate('/login');
  };

  return (
    <div className="profile-page">
      <BackgroundAnimation />

      <div className="profile-container">
        <span className="lock-icon" onClick={handlePrivateAreaClick} title="Espace privé">🔒</span>

        <div className="profile-header">
          <p className="eyebrow"><span className="prompt">~$</span> whoami</p>

          <div className="profile-image-wrapper">
            <img src={`${process.env.PUBLIC_URL}/profil.png`} alt="Profile" className="profile-image" />
          </div>

          <h1 className="name-box"><ShinyText text="Jeremy LEFORT-BESNARD" disabled={false} speed={9} /></h1>
          <p className="role-line">Ingénieur IA embarquée</p> 
          <p className="role-line">et responsable de projets</p>
          <p className="role-line">à l'Agence Ministérielle pour l'IA de Défense (AMIAD)</p>
          <p className="location-line">Rennes, France 🇫🇷</p>
        </div>

        <nav className="nav-links">
          {navLinks.map((link, index) => (
            link.href ? (
              <a key={index} href={link.href} target="_blank" rel="noopener noreferrer" className="nav-pill">
                {link.label} <span className="nav-pill-arrow">↗</span>
              </a>
            ) : (
              <button key={index} type="button" onClick={link.action} className="nav-pill">
                {link.label}
              </button>
            )
          ))}
        </nav>

        <div className="profile-footer">
          <p className="email-box"><span className="prompt">&gt;</span> {displayedEmail}<span className="cursor">_</span></p>
        </div>
      </div>
    </div>
  );
};

export default Profile;
